import React from "react";
import { fetchFile } from "@api";
import { Spinner } from "./Spinner";

type Props = {
  fileUrl: string;
  width?: number | string;
  style?: React.CSSProperties;
};

type State = {
  showSpinner: boolean;
};

export class ImageLoader extends React.Component<Props, State> {
  state: State = {
    showSpinner: false
  };

  timer = null;

  fetchFile = () => {
    const { fileUrl } = this.props;
    fetchFile(fileUrl).then((code) => {
      if (!code) {
        this.timer = setTimeout(this.fetchFile, 500);
        if (!this.state.showSpinner) {
          this.setState({ showSpinner: true });
        }
      } else if (code && this.state.showSpinner) {
        this.setState({ showSpinner: false });
      }
    });
  };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const { fileUrl, style, width = 128 } = this.props;

    return (
      <div>
        {!this.state.showSpinner && (
          <img
            src={fileUrl}
            onError={(e) => {
              this.fetchFile();
            }}
            style={{ width, ...style }}
          />
        )}
        {this.state.showSpinner && <Spinner />}
      </div>
    );
  }
}
